// Helper to handle blob (file) requests
export async function fetchBlobWithHandling(url, options = {}) {
    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            // Try to parse error as text or JSON
            let errorText = await res.text();
            try {
                const errJson = JSON.parse(errorText);
                errorText = errJson.message || errJson.error || errorText;
            } catch {}
            return { status: res.status, error: errorText };
        }
        const blob = await res.blob();
        return { status: res.status, blob, headers: res.headers };
    } catch (err) {
        return { error: err?.message || 'Network error', networkError: true };
    }
}

// Helper to handle fetch and errors
export async function fetchWithHandling(url, options = {}) {
    try {
        const res = await fetch(url, options);
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            const message = (data && (data.detail || data.title || data.message || data.error)) || res.statusText || 'Unknown error';
            // Preserve status and raw details for callers to map to inline field errors
            return { status: res.status, error: message, details: data };
        }
        return { status: res.status, data };
    } catch (err) {
        // Network or unexpected runtime error
        return { error: err?.message || 'Network error', networkError: true };
    }
}
